//import React from 'react';
import Frame1 from '../images/Frame1.png';
import Frame2 from '../images/Frame2.png';
import Frame3 from '../images/Frame3.png';
import Frame4 from '../images/Frame4.png';
import Frame5 from '../images/Frame5.png';
import Frame6 from '../images/Frame6.png';
import Frame7 from '../images/Frame7.png';
import Frame8 from '../images/Frame8.png';
import Frame9 from '../images/Frame9.png';
import Frame10 from '../images/Frame10.png';
import Frame11 from '../images/Frame11.png';
import Frame12 from '../images/Frame12.png';
import Frame15 from '../images/Frame15.png';
import Frame16 from '../images/Frame16.png';
import Frame17 from '../images/Frame17.png';
import Frame18 from '../images/Frame18.png';
import Frame19 from '../images/Frame19.png';
import Frame20 from '../images/Frame20.png';
import Frame22 from '../images/Frame22.png';
import Frame23 from '../images/Frame23.png';
import Frame24 from '../images/Frame24.png';
import Frame25 from '../images/Frame25.png';
import Frame26 from '../images/Frame26.png';
import Frame28 from '../images/Frame28.png';
import Frame33 from '../images/Frame33.png';

import AndraPradeshData from '../StatesLeads/AndraPradesh';
import ArunachalPradeshData from '../StatesLeads/ArunachalPradesh';
import AssamData from '../StatesLeads/Assam';
import BiharData from '../StatesLeads/Bihar';
import ChhattisgarhData from '../StatesLeads/Chhattisgarh';
import ChandigarhData from '../StatesLeads/Chandigarh';
import DamanAndDiuData from '../StatesLeads/DamanAndDiu';
import DelhiData from '../StatesLeads/Delhi';
import GoaData from '../StatesLeads/Goa';
import GujratData from '../StatesLeads/Gujrat';
import HaryanaData from '../StatesLeads/Haryana';
import HimachalPradeshData from '../StatesLeads/HimachalPradesh';
import JammuAndKashmirData from '../StatesLeads/JammuAndKashmir';
import JharkhandData from '../StatesLeads/Jharkhand';
import KarnatakaData from '../StatesLeads/Karnataka';
import KeralaData from '../StatesLeads/Kerala';
import LadakhData from '../StatesLeads/Ladakh';
import LakshadweepData from '../StatesLeads/Lakshadweep';
import MadhyaPradeshData from '../StatesLeads/MadhyaPradesh';
import MaharashtraData from '../StatesLeads/Maharashtra';
import ManipurData from '../StatesLeads/Manipur';
import MizoramData from '../StatesLeads/Mizoram';
import NagalandData from '../StatesLeads/Nagaland';
import OrissaData from '../StatesLeads/Orissa';
import PuducherryData from '../StatesLeads/Puducherry';
import PunjabData from '../StatesLeads/Punjab';
import RajasthanData from '../StatesLeads/Rajasthan';
import SikkimData from '../StatesLeads/Sikkim';
import TamilNaduData from '../StatesLeads/TamilNadu';
import TripuraData from '../StatesLeads/Tripura';
import UttarakhandData from '../StatesLeads/Uttarakhand';
import UttarPradeshData from '../StatesLeads/UttarPradesh';
import WestBengalData from '../StatesLeads/WestBengal';



const StateCardData = [
    {
        id: "8",
        img: Frame25 ,
        stateName: 'Delhi',
        stateLeadsData: DelhiData ,
        Title:"Delhi",
    },
    {
        id: "1",
        img: Frame1,
        stateName: 'AndraPradesh',
        stateLeadsData: AndraPradeshData,
        Title:"Andhra Pradesh",

    },
    {
        id: "2",
        img: Frame24,
        stateName: 'Assam',
        stateLeadsData: AssamData ,
        Title:"Assam",
    },
    {
        id: "3",
        img: Frame3,
        stateName: 'ArunachalPradesh',
        stateLeadsData: ArunachalPradeshData,
        Title:"Arunachal Pradesh",
    },
    {
        id: "4",
        img: Frame4,
        stateName: 'Bihar',
        stateLeadsData: BiharData,
        Title:"Bihar",
    },
    {
        id: "5",
        img: Frame5,
        stateName: 'Chhattisgarh',
        stateLeadsData: ChhattisgarhData,
        Title:"Chattisgarh",
    },
    {
        id: "6",
        img: Frame6,
        stateName: 'Chandigarh',
        stateLeadsData: ChandigarhData,
        Title:"Chandigarh",

    },
    {
        id: "7",
        img: Frame7,
        stateName: 'DamanAndDiu',
        stateLeadsData: DamanAndDiuData,
        Title:"Daman And Diu",
    },
   
    {
        id: "9",
        img: Frame9,
        stateName: 'Goa',
        stateLeadsData: GoaData,
        Title:"Goa",
    },
    {
        id: "10",
        img: Frame10,
        stateName: 'Gujrat',
        stateLeadsData: GujratData,
        Title:"Gujrat",

    },
    {
        id: "11",
        img: Frame11,
        stateName: 'Haryana',
        stateLeadsData: HaryanaData,
        Title:"Haryana",
    },
    {
        id: "12",
        img: Frame12,
        stateName: 'HimachalPradesh',
        stateLeadsData: HimachalPradeshData,
        Title:"Himachal Pradesh",
    },
    {
        id: "13",
        img: Frame15,
        stateName: 'JammuAndKashmir',
        stateLeadsData: JammuAndKashmirData,
        Title:"Jammu And Kashmir",
    },
    {
        id: "14",
        img: Frame16,
        stateName: 'Jharkhand',
        stateLeadsData: JharkhandData,
        Title:"Jharkhand",
    },
    {
        id: "15",
        img: Frame17,
        stateName: 'Karnataka',
        stateLeadsData: KarnatakaData,
        Title:"Karnataka",
    },
    {
        id: "16",
        img: Frame18,
        stateName: 'Kerala',
        stateLeadsData: KeralaData,
        Title:"Kerala",
    },
    {
        id: "17",
        img: Frame19,
        stateName: 'Ladakh',
        stateLeadsData: LadakhData,
        Title:"Ladakh",
    },
    {
        id: "18",
        img: Frame20,
        stateName: 'Lakshadweep',
        stateLeadsData: LakshadweepData ,
        Title:"Lakshadweep",
    },
    {
        id: "19",
        img:  Frame22,
        stateName: 'MadhyaPradesh',
        stateLeadsData: MadhyaPradeshData,
        Title:"Madhya Pradesh",
    },
    {
        id: "20",
        img:  Frame11,
        stateName: 'Maharashtra',
        stateLeadsData: MaharashtraData,
        Title:"Mahrashtra",
    },
    {
        id: "21",
        img: Frame23,
        stateName: 'Manipur',
        stateLeadsData: ManipurData,
        Title:"Manipur",
    },
    {
        id: "22",
        img: Frame24,
        stateName: 'Mizoram',
        stateLeadsData: MizoramData,
        Title:"Mizoram",
    },
    {
        id: "23",
        img: Frame8,
        stateName: 'Nagaland',
        stateLeadsData: NagalandData,
        Title:"Nagaland",
    },
    {
        id: "24",
        img: Frame26,
        stateName: 'Orissa',
        stateLeadsData: OrissaData,
        Title:"Orissa",
    },
    {
        id: "25",
        img: Frame28,
        stateName: 'Puducherry',
        stateLeadsData: PuducherryData,
        Title:"Puducherry",
    },
    {
        id: "26",
        img: Frame33,
        stateName: 'Punjab',
        stateLeadsData: PunjabData,
        Title:"Punjab",
    },
    {
        id: "27",
        img: Frame2,
        stateName: 'Rajasthan',
        stateLeadsData: RajasthanData,
        Title:"Rajasthan",
    },
    {
        id: "28",
        img: Frame9,
        stateName: 'Sikkim',
        stateLeadsData: SikkimData,
        Title:"Sikkim",
    },
    {
        id: "29",
        img: Frame6,
        stateName: 'TamilNadu',
        stateLeadsData: TamilNaduData,
        Title:"Tamil Nadu",
    },
    {
        id: "30",
        img: Frame3,
        stateName: 'Tripura',
        stateLeadsData: TripuraData,
        Title:"Tripura",
    },
    {
        id: "31",
        img: Frame2,
        stateName: 'Uttarakhand',
        stateLeadsData: UttarakhandData,
        Title:"Uttarakhand",
    },
    {
        id: "32",
        img: Frame24,
        stateName: 'UttarPradesh',
        stateLeadsData: UttarPradeshData,
        Title:"Uttar Pradesh"
    },
    {
        id: "33",
        img: Frame1,
        stateName: 'WestBengal',
        stateLeadsData: WestBengalData,
        Title:"West Bengal",
    },

];

export default StateCardData